import { ema, sma, rsi, atr, bollingerBand, macd, stochasticOscillator, sar } from "react-stockcharts/lib/indicator";
import algo from "react-stockcharts/lib/algorithm";
import {generateBacktestReport} from './Backtest';

let stockAlgoList = [];

let emaLowValue = 13;
let emaHighValue = 50;

let smaLowValue = 10;
let smaHighValue = 20;


const smaLow = sma()
    .id(0)
    .options({ windowSize: smaLowValue })
    .merge((d, c) => { d.smaLow = c; })
    .accessor(d => d.smaLow);

const smaHigh = sma()
    .id(2)
    .options({ windowSize: smaHighValue })
    .merge((d, c) => { d.smaHigh = c; })
    .accessor(d => d.smaHigh);

const emaLow = ema()
    .id(0)
    .options({ windowSize: emaLowValue })
    .merge((d, c) => { d.emaLow = c; })
    .accessor(d => d.emaLow);

const emaHigh = ema()
    .id(2)
    .options({ windowSize: emaHighValue })
    .merge((d, c) => { d.emaHigh = c; })
    .accessor(d => d.emaHigh);

const rsiCalculator = rsi()
    .options({ windowSize: 14 })
    .merge((d, c) => { d.rsi = c; })
    .accessor(d => d.rsi);

const atr14 = atr()
    .options({ windowSize: 14 })
    .merge((d, c) => { d.atr14 = c; })
    .accessor(d => d.atr14);

const bb = bollingerBand()
    .merge((d, c) => { d.bb = c; })
    .accessor(d => d.bb);

const macdCalculator = macd()
    .options({
        fast: 12,
        slow: 26,
        signal: 9,
    })
    .merge((d, c) => { d.macd = c; })
    .accessor(d => d.macd);

const fullSTO = stochasticOscillator()
    .options({ windowSize: 14, kWindowSize: 3, dWindowSize: 4 })
    .merge((d, c) => { d.fullSTO = c; })
    .accessor(d => d.fullSTO);

const sarAccelerationFactor = .02;
const sarMaxAccelerationFactor = .2;
const defaultSar = sar()
    .options({
        sarAccelerationFactor, sarMaxAccelerationFactor
    })
    .merge((d, c) => { d.sar = c; })
    .accessor(d => d.sar);

const buySellEma = algo()
    .windowSize(2)
    .accumulator(([prev, now]) => {
        const { emaLow: prevShortTerm, emaHigh: prevLongTerm } = prev;
        const { emaLow: nowShortTerm, emaHigh: nowLongTerm } = now;
        if (prevShortTerm < prevLongTerm && nowShortTerm > nowLongTerm) return "LONG";
        if (prevShortTerm > prevLongTerm && nowShortTerm < nowLongTerm) return "SHORT";
    })
    .merge((d, c) => { d.emaLongShort = c; });

const buySellSma = algo()
    .windowSize(2)
    .accumulator(([prev, now]) => {
        const { smaLow: prevShortTerm, smaHigh: prevLongTerm } = prev;
        const { smaLow: nowShortTerm, smaHigh: nowLongTerm } = now;
        if (prevShortTerm < prevLongTerm && nowShortTerm > nowLongTerm) return "LONG";
        if (prevShortTerm > prevLongTerm && nowShortTerm < nowLongTerm) return "SHORT";
    })
    .merge((d, c) => { d.smaLongShort = c; });

const buySellMacd = algo()
    .windowSize(2)
    .accumulator(([prev, now]) => {
        if (prev.macd.divergence < 0 && now.macd.divergence > 0) return "LONG";
        if (prev.macd.divergence > 0 && now.macd.divergence < 0) return "SHORT";
    })
    .merge((d, c) => { d.macdLongShort = c; });

const buySellRsi = algo()
    .windowSize(2)
    .accumulator(([prev, now]) => {
        if (prev.rsi > 30 && now.rsi < 30) return "LONG";
        if (prev.rsi < 70 && now.rsi > 70) return "SHORT";
    })
    .merge((d, c) => { d.rsiLongShort = c; });

const custom_sort = (a, b) => {
    return b.totalProfit - a.totalProfit;
}

const calculateAndBestStratergy = (data) => {
    console.log('calculateAndBestStratergy', data);
    if (!(data !== undefined && data.length !== undefined && data.length > 0)) {
        return undefined;
    }
    let report = undefined;
    let indicatorCalculatedData = fullSTO(smaHigh(smaLow(emaHigh(emaLow(rsiCalculator(atr14(bb(macdCalculator(defaultSar(data))))))))));
    let emaCalculatedData = buySellEma(indicatorCalculatedData);
    let macdCalculatedData = buySellMacd(indicatorCalculatedData);
    let rsiCalculatedData = buySellRsi(indicatorCalculatedData);
    let smaCalculatedData = buySellSma(indicatorCalculatedData);

    let calculatedData = smaCalculatedData;
    let profitList = [];
    let stratergyList = ['EMA', 'SMA', 'MACD', 'RSI'];
    let stratergyNameList = ['EMA Crossover', 'SMA Crossover', 'MACD', 'RSI'];
    for (var i=0; i<stratergyList.length; i++){
        let profit = generateBacktestReport(calculatedData, stratergyList[i], stratergyNameList[i]);
        profitList.push(profit);
    }
    profitList.sort(custom_sort);

    console.log('All calcualted profitlist chartAlgoWrap data ', profitList, calculatedData);

    report = {
        data: calculatedData,
        profitList: profitList,
    }
    return report;
}

const setStockAlgoList = (data) => {
    stockAlgoList = data;
}

const getStockAlgoList = () => {
    return stockAlgoList;
}

export { calculateAndBestStratergy, setStockAlgoList,  getStockAlgoList};